/**
 * @name StatsController
 * @description Controller for shop stats
 * @param {type} $scope Description
 * @param {type} $interval Description
 * @param {type} Appointments Description
 * @param {type} StatsFactory Description
 * @param {type} Schedule Description
 * @param {service} ShopGoals The ShopGoals service
 * @param {type} ShopHours Description
 * @param {type} ScheduleUtilFactory Description
 * @param {type} Events Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 */
function StatsController(
  $scope,
  $interval,
  Appointments,
  StatsFactory,
  Schedule,
  ShopGoals,
  ShopHours,
  ScheduleUtilFactory,
  Events,
  Session,
  _
) {
  let vm = this;
  let statsTimer;

  vm.updateFilter = setIntervals;
  vm.intervalSelect = 'today';
  vm.period = '';
  vm.current = {};
  vm.updating = false;
  vm.adverb = '';
  vm.statsToggle = statsToggle;
  vm.events = Events;
  vm.session = Session;

  /**
   * @name statsToggle
   * @description Function to toggle the stats shelf open and closed
   */
  function statsToggle() {
    if (Events.statsOpen === false) {
      Events.statsOpen = true;
    } else {
      Events.statsOpen = false;
    }
  }
  setIntervals();
  statsTimer = $interval(update, 60000);

  // Called to Reset Data on Logout
  $scope.$on('clear-data', function() {
    $interval.cancel(statsTimer);
  });

  /**
   * @name update
   * @description Function to update stats.
   */
  function update() {
    vm.updating = true;
    if (Session.activeState.role === 'operator') {
      if (!_.isUndefined(Session.activeState.association)) {
        ShopHours.get(Session.activeState.association.shop.id)
        .then(function(hours) {
          StatsFactory.shopHours = hours.all;
          StatsFactory.resetIntervalTimes();
          let start = StatsFactory.periodRange.start;
          let end = StatsFactory.periodRange.end;
          let search = false;
          let timestamp = null;

          Appointments.get(search, start, end, timestamp)
          .then(function(appointments) {
            StatsFactory.appointments = appointments;
            Schedule.fetchSchedules().then(function(rules) {
              let allInstances =
              ScheduleUtilFactory.generateRuleInstances(rules, start, end);
              StatsFactory.schedules =
              ScheduleUtilFactory.filterExceptions(allInstances);

              ShopGoals.get().then(function(goals) {
                StatsFactory.goals = goals;
                StatsFactory.resetDataStats();
                StatsFactory.recalculateStats();
                vm.current = StatsFactory.currentPeriod;
                vm.updating = false;
              });
            });
          });
        });
      }
    }
  }

  /**
   * @name setIntervals
   * @description Function to set the intervals of the quick stats shelf.
   */
  function setIntervals() {
    vm.updating = true;

    let number;
    let interval;
    interval = vm.intervalSelect;

    if (interval.indexOf('week') >= 0) {
      vm.period = 'week';
    } else if (interval.indexOf('month') >= 0) {
      vm.period = 'month';
    } else if (interval.indexOf('quarter') >= 0) {
      vm.period = 'quarter';
    } else if (interval.indexOf('year') >= 0) {
      vm.period = 'year';
    } else {
      vm.period = 'day';
    }

    if (vm.period === 'day') {
      vm.adverb = 'daily';
    } else {
      vm.adverb = vm.period + 'ly';
    }

    if (interval.indexOf('this') >= 0 || interval.indexOf('today') >= 0) {
      number = 0;
    } else {
      number = 1;
    }
    if (vm.intervalSelect === 'today') {
      Events.statsDateRange = 'today';
    } else if (vm.intervalSelect === 'yesterday') {
      Events.statsDateRange = 'yesterday';
    } else if (vm.intervalSelect === 'this_week') {
      Events.statsDateRange = 'this week';
    } else if (vm.intervalSelect === 'this_month') {
      Events.statsDateRange = 'this month';
    } else if (vm.intervalSelect === 'this_quarter') {
      Events.statsDateRange = 'this quarter';
    } else if (vm.intervalSelect === 'this_year') {
      Events.statsDateRange = 'this year';
    } else if (vm.intervalSelect === 'last_week') {
      Events.statsDateRange = 'last week';
    } else if (vm.intervalSelect === 'last_month') {
      Events.statsDateRange = 'last month';
    } else if (vm.intervalSelect === 'last_quarter') {
      Events.statsDateRange = 'last quarter';
    } else if (vm.intervalSelect === 'last_year') {
      Events.statsDateRange = 'last year';
    }

    StatsFactory.resetIntervals(vm.period, number);
    update();
  }
}

angular
  .module('inkfinder')
  .controller('StatsController', StatsController);



// WEBPACK FOOTER //
// ./components/stats/stats.controller.js